function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M4.70633428,3.74544672 L4.70495433,3.74400689 L5.02791686,3.40991038 L5.99582867,2.4 L6,2.40431513 L6.00417133,2.4 L6.97208314,3.40991038 L7.29504567,3.74400689 L7.29366572,3.74544672 L12,8.65599311 L10.700783,10 L6,5.09524576 L1.29921699,10 L-9.57012247e-14,8.65599311 L4.70633428,3.74544672 Z",
  id: "path-1"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Icons-/-Navigation-/-ic_arrow_down",
  transform: "translate(0.000000, -2.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "Combined-Shape",
  fillOpacity: 0.5,
  fill: "#FFFFFF",
  fillRule: "evenodd",
  transform: "translate(6.000000, 6.200000) rotate(-180.000000) translate(-6.000000, -6.200000) ",
  xlinkHref: "#path-1"
})));

var SvgIconArrowDownWhite = function SvgIconArrowDownWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "6px",
    viewBox: "0 0 12 8",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconArrowDownWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-arrow-down-white.ce4786cb.svg";
export { ForwardRef as ReactComponent };